import { useState } from "react";
import { MbaplFinancialReporting } from "./MbaplFinancialReporting";
import FinancialReporting from "./FinancialReporting";
import { KplFinancialReporting } from "./KplFinancialReporting";

const tabs = ["Ostwal", "MBAPL", "KPL"];

const MainFinancialReporting = () => {
  const [activeTab, setActiveTab] = useState("Ostwal");

  const renderContent = () => {
    switch (activeTab) {
      case "Ostwal":
        return <FinancialReporting />;
      case "MBAPL":
        return <MbaplFinancialReporting />;
      case "KPL":
        return <KplFinancialReporting />;
      default:
        return null;
    }
  };

  return (
    <>
      <div className="p-4 md:p-6">
        {/* Tabs */}
        <div className="flex items-center gap-4 mb-4 border-b pb-2">
          {tabs.map((tab) => (
            <button
              key={tab}
              type="button"
              onClick={() => setActiveTab(tab)}
              className={`px-4 py-2 rounded-t-md font-medium transition-colors duration-150 cursor-pointer ${
                activeTab === tab
                  ? "text-[#E2544B] border-b-2 border-[#E2544B]"
                  : "text-gray-500 hover:text-[#E2544B]"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Tab Content */}
        <div className="mt-4">{renderContent()}</div>
      </div>
    </>
  );
};

export default MainFinancialReporting;
